import React, { useState } from "react";
import PaginateComponent from "../../Helpers/PaginateComponent";
import EventoContactoCDITable from "./EventoContactoCDITable";

export default function ContactPaginate({ info, loadingInfo }) {
  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 5;
  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(info?.length / PER_PAGE);
  const currentPageData = info?.slice(offset, offset + PER_PAGE);
  return (
    <>
      <EventoContactoCDITable
        info={currentPageData}
        loadingInfo={loadingInfo}
      />

      <PaginateComponent
        pageCount={pageCount}
        currentPageData={currentPageData}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
}
